<template>
    <UButton
        type="button"
        tabindex="0"
        :ui="buttonUi"
        :loading="config.loading"
        :block="config.block"
        @click.stop="config.onClick()"
    >
        <template v-if="hasContentChildren">
            <div class="inline-flex w-full flex-row justify-center items-center gap-2.5">
                <template v-for="item in config.content" :key="item.id">
                    <TextBlock v-if="item.type === 'text'" :config="item"></TextBlock>
                    <LinesBlock v-else-if="item.type === 'lines'" :config="item"></LinesBlock>
                    <NestedButtonBlock
                        v-else-if="item.type === 'button'"
                        :config="item"
                    ></NestedButtonBlock>
                    <ImageBlock v-else-if="item.type === 'image'" :config="item"></ImageBlock>
                    <IconBlock v-else-if="item.type === 'icon'" :config="item"></IconBlock>
                    <SectionBlock v-else-if="item.type === 'section'" :config="item"></SectionBlock>
                    <RowBlock v-else-if="item.type === 'row'" :config="item"></RowBlock>
                    <AdditionalColorsPricingBlock
                        v-else-if="item.type === 'additional-colors-pricing'"
                        :config="item"
                    />
                </template>
            </div>
        </template>
        <span v-else v-html="sanitizedText"></span>
    </UButton>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import AdditionalColorsPricingBlock from './AdditionalColorsPricingBlock.vue'
import IconBlock from './IconBlock.vue'
import ImageBlock from './ImageBlock.vue'
import LinesBlock from './LinesBlock.vue'
import RowBlock from './RowBlock.vue'
import SectionBlock from './SectionBlock.vue'
import TextBlock from './TextBlock.vue'
import { defuStrConcat } from '@/utils/defuStrConcat'
import { sanitizeHtml } from '@/utils/sanitizeHtml'
import type { ButtonBlockConfig } from '~~/layers/base/types/blockConfigs'

const NestedButtonBlock = defineAsyncComponent(
    // eslint-disable-next-line import/no-self-import -- recursive nested `ButtonBlock` configs
    () => import('./ButtonBlock.vue')
)

const props = defineProps<{
    config: ButtonBlockConfig
}>()

const staticButtonClass = 'cursor-pointer touch-manipulation'
const buttonUi = computed(() => defuStrConcat({ base: staticButtonClass }, props.config.ui ?? {}))

const hasContentChildren = computed(
    () => props.config.content != null && props.config.content.length > 0
)

const sanitizedText = computed(() => sanitizeHtml(props.config.text ?? ''))
</script>
